import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { AdminRoute, PrivateRoute, TemporaryRoute } from './routes/guards';
import { Paths, legacyRedirects } from './routes/paths';
import { LoginPage } from './pages/LoginPage';
import { LogoutPage } from './pages/LogoutPage';
import { AuthOptionsPage } from './pages/AuthOptionsPage';
import { HomePage } from './pages/HomePage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { ConfirmEmailPage } from './pages/ConfirmEmailPage';
import { UpdateRolePage } from './pages/UpdateRolePage';
import { ApiTokenPage } from './pages/ApiTokenPage';
import { AdminStatsPage } from './pages/AdminStatsPage';
import { ApplicationPage } from './pages/ApplicationPage';
import { MappingsPage } from './pages/MappingsPage';
import { RegisterUserPage } from './pages/RegisterUserPage';
import { UsersPage } from './pages/UsersPage';
import { ProfilePage } from './pages/ProfilePage';
import { HelpPage } from './pages/HelpPage';

export function App() {
    return (
        <BrowserRouter>
            <AppShell>
                <Routes>
                    {/* Public */}
                    <Route path={Paths.login} element={<LoginPage controller="login" />} />
                    <Route path={Paths.adLogin} element={<LoginPage controller="activeDirectory" />} />
                    <Route path={Paths.logout} element={<LogoutPage />} />
                    <Route path={Paths.confirmEmail} element={<ConfirmEmailPage />} />
                    <Route path={Paths.forgotPassword} element={<ForgotPasswordPage />} />
                    <Route path={Paths.resetPassword} element={<ResetPasswordPage />} />

                    {/* Mid-2FA */}
                    <Route element={<TemporaryRoute />}>
                        <Route path={Paths.authOptions} element={<AuthOptionsPage />} />
                    </Route>

                    {/* Signed-in */}
                    <Route element={<PrivateRoute />}>
                        <Route path={Paths.home} element={<HomePage />} />
                        <Route path={Paths.profile} element={<ProfilePage />} />
                        <Route path={Paths.updateRole} element={<UpdateRolePage />} />
                        <Route path={Paths.help} element={<HelpPage />} />
                    </Route>

                    {/* Admin */}
                    <Route element={<AdminRoute />}>
                        <Route path={Paths.smartStore} element={<MappingsPage />} />
                        <Route path={Paths.register} element={<RegisterUserPage />} />
                        <Route path={Paths.addApplication} element={<ApplicationPage />} />
                        <Route path={Paths.usersOverview} element={<UsersPage />} />
                        <Route path={Paths.generateToken} element={<ApiTokenPage />} />
                        <Route path={Paths.adminStats} element={<AdminStatsPage />} />
                    </Route>

                    {/* Legacy path aliases → new canonical routes, so old
                        bookmarks/links keep resolving after the rename. */}
                    {Object.entries(legacyRedirects).map(([from, to]) => (
                        <Route key={from} path={from} element={<Navigate to={to} replace />} />
                    ))}

                    <Route path="*" element={<Navigate to={Paths.home} replace />} />
                </Routes>
            </AppShell>
        </BrowserRouter>
    );
}
